








































import {Vue, Component, Prop} from 'vue-property-decorator';
import {FileManagerEvents} from '@/events';
import FileInspector from '@/components/FileInspector.vue';
import FileSystemBreadcrumb from '@/components/FileSystemBreadcrumb.vue';
import Directory from '@/model/Directory';
import FileUploader from '@/components/FileUploader.vue';
import eventBus from '@/EventBus';
import mutations from '@/mutations';
import AlertType from '@/enums/AlertType';

@Component({
	name: 'FileManager',
	components: {
		FileUploader,
		FileInspector,
		FileSystemBreadcrumb
	}
})
export default class FileManager extends Vue {
	@Prop()
	private apiBaseUrl: string;

	@Prop()
	private acceptedFileTypes: string[];

	private showAlert: boolean = false;
	private alertText: string = null;
	private alertType: string = null;

	private fileInspector: FileInspector = null;
	private currentDirectory: Directory = null;

	constructor()
	{
		super();

		this.$store.commit(mutations.updateApiBaseUrl, this.apiBaseUrl);

		eventBus.$on(FileManagerEvents.fileSystemObjectClicked, this.onFileSystemObjectClicked);
	}

	public mounted()
	{
		this.fileInspector = this.$refs.fileInspector as FileInspector;
	}

	public alert(text: string, type: AlertType, displayTime?: number)
	{
		this.showAlert = true;
		this.alertText = text;
		this.alertType = type;

		displayTime = displayTime ? displayTime : 3000;

		setTimeout(() => {
			this.showAlert = false;
			this.alertText = null;
			this.alertType = null;
		}, displayTime);
	}

	public openDirectory(directory: Directory)
	{
		this.fileInspector.openDirectory(directory);
	}

	public onParentDirectoryClicked()
	{
		this.resetActionHint();

		this.openDirectory(this.currentDirectory.parent);
	}

	public onFileSystemLocationChanged(directory: Directory)
	{
		this.currentDirectory = directory;
	}

	public onReloadClicked()
	{
		this.resetActionHint();

		//todo: investigate if this needs performance improvements (whole file system will be reloaded at once!)
		this.fileInspector.loadFileSystem();
	}

	public onDropParentDirectory(transferData: any)
	{
		this.resetActionHint();

		if (transferData.fileSystemObjectModel && this.currentDirectory.parent)
		{
			this.fileInspector.moveFileSystemObjectModel(transferData.fileSystemObjectModel, this.currentDirectory.parent);
		}
	}

	public onCreateDirectoryClicked()
	{
		this.resetActionHint();

		this.fileInspector.createDirectory();
	}

	public onDownloadCurrentDirectoryClicked()
	{
		this.resetActionHint();

		this.fileInspector.downloadCurrentDirectory();
	}

	public onFileSystemObjectClicked(data: any)
	{
		if (data.fileSystemObjectModel)
		{
			const event = new CustomEvent(FileManagerEvents.fileSystemObjectClicked, {detail: data});
			this.$root.$el.dispatchEvent(event);
		}
	}

	private resetActionHint()
	{
		this.$store.dispatch('resetActionHint');
	}
}
